import { combineReducers } from 'redux'
import video from './video'
import videos from './videos'
import me from './me'
import clipper from './clipper'
import stats from './stats'
import checkout from './checkout'
import app from './app'

const rootReducer = combineReducers({
  video,
  videos,
  me,
  clipper,
  stats,
  checkout,
  app,
})

export default rootReducer
